import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal, DatePicker, Viewer } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { DriverService } from 'services';

interface Props extends RootState, RouteComponentProps {
	dispatch: any;
	item: any;
	onClose: any;
}

class ModalCreate extends React.Component<Props> {

	state = {
		form: {
			name: '',
			email: '',
			phone: '',
			city: ''
		}
	}

	submit = async () => {
		await DriverService.invitations.send({
			...this.state.form
		});
		Globals.showSuccess("Se ha enviado la invitación correctamente");
		this.props.onClose();
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	render() {
		return (
			<div id="modal-create-invitation">
				<div className="row">
					<div className="col-md-6">
						<Input
							label="Nombre"
							value={this.state.form?.name}
							name="name"
							onChange={(e: any) => this.change(e)}
							notMui
						/>
					</div>
					<div className="col-md-6">
						<Input
							label="Correo electrónico"
							value={this.state.form?.email}
							name="email"
							onChange={(e: any) => this.change(e)}
							notMui
						/>
					</div>
					<div className="col-md-6">
						<Input
							type="number"
							maxLength={ 11 }
							label="Teléfono"
							value={this.state.form?.phone}
							name="phone"
							onChange={(e: any) => this.change(e)}
							notMui
						/>
					</div>
					<div className="col-md-6">
						<Input
							label="Ciudad"
							value={this.state.form?.city}
							name="city"
							onChange={(e: any) => this.change(e)}
							notMui
						/>
					</div>
				</div>
				<div className="text-center">
					<button className="btn btn-blue" onClick={ () => this.submit() }>
						Guardar
					</button>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(ModalCreate);